const TiktokLogo = ({ white = false }) => (
  <svg viewBox="0 0 64 64">
    {!white && (
      <>
        <path
          d="M35 14c1.5 5.5 5.5 9.5 11 11v7c-4-.2-7.8-1.5-11-4v13c0 8-5.8 13-13.2 13C15.1 54 10 49.2 10 42.8c0-6.4 5.1-11.2 11.8-11.2 1.3 0 2.5.2 3.6.6v7c-1-.7-2.2-1.1-3.6-1.1-3 0-5.3 2.1-5.3 4.7 0 2.7 2.3 4.8 5.3 4.8 3.1 0 5.3-2.2 5.3-5.4V14z"
          fill="#25F4EE"
          transform="translate(-2 2)"
        />

        <path
          d="M35 14c1.5 5.5 5.5 9.5 11 11v7c-4-.2-7.8-1.5-11-4v13c0 8-5.8 13-13.2 13C15.1 54 10 49.2 10 42.8c0-6.4 5.1-11.2 11.8-11.2 1.3 0 2.5.2 3.6.6v7c-1-.7-2.2-1.1-3.6-1.1-3 0-5.3 2.1-5.3 4.7 0 2.7 2.3 4.8 5.3 4.8 3.1 0 5.3-2.2 5.3-5.4V14z"
          fill="#FE2C55"
          transform="translate(2 -2)"
        />
      </>
    )}

    <path
      d="M35 14c1.5 5.5 5.5 9.5 11 11v7c-4-.2-7.8-1.5-11-4v13c0 8-5.8 13-13.2 13C15.1 54 10 49.2 10 42.8c0-6.4 5.1-11.2 11.8-11.2 1.3 0 2.5.2 3.6.6v7c-1-.7-2.2-1.1-3.6-1.1-3 0-5.3 2.1-5.3 4.7 0 2.7 2.3 4.8 5.3 4.8 3.1 0 5.3-2.2 5.3-5.4V14z"
      fill={white ? '#fff' : '#111'}
    />
  </svg>
);

export default TiktokLogo;
